import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, MessageCircleIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { business } from '../data/business';
import { Logo } from './Logo';
const navLinks = [{
  href: '#home',
  key: 'navHome'
}, {
  href: '#services',
  key: 'navServices'
}, {
  href: '#gallery',
  key: 'navGallery'
}, {
  href: '#about',
  key: 'navAbout'
}, {
  href: '#faq',
  key: 'navFaq'
}, {
  href: '#contact',
  key: 'navContact'
}] as const;
export function Navbar() {
  const {
    t,
    lang,
    toggle
  } = useLanguage();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className="sticky top-0 z-40 border-b border-navy/10 bg-white shadow-sm" data-id="element-260" data-mp="1pwzxupbnb98y">
      <nav aria-label="Main navigation" className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-4 sm:px-6 lg:px-8" data-id="element-261" data-mp="1kyolo7xvomnk">
        <Logo data-id="element-262" data-mp="enapkr1ew4gl" />

        <ul className="hidden items-center gap-7 lg:flex" data-id="element-263" data-mp="emri649e0ygt">
          {navLinks.map(link => <li key={link.href} data-id="element-264" data-mp="jmdtg85no4mz">
              <a href={link.href} className="font-display text-sm font-bold text-charcoal transition-colors duration-150 ease-out hover:text-royal" data-id="element-265" data-mp="jn6s0lugnnu1">
                {t(copy[link.key])}
              </a>
            </li>)}
        </ul>

        <div className="hidden items-center gap-2 lg:flex" data-id="element-266" data-mp="3s38k8p96hykp">
          <a href={business.phoneHref} className="flex items-center gap-2 rounded-lg px-2 py-2 font-display text-sm font-bold text-royal transition-colors duration-150 ease-out hover:bg-mist" data-id="element-267" data-mp="vmd2mn93dz3">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-268" data-mp="34c37iiyjbmem" />
            {business.phone}
          </a>
          <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label={t(copy.whatsappUs)} className="rounded-lg p-2 text-charcoal/70 transition-colors duration-150 ease-out hover:bg-mist hover:text-royal" data-id="element-269" data-mp="39ao66dy51y0y">
            <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-270" data-mp="3azrqymjgin0c" />
          </a>
          <button type="button" onClick={toggle} aria-label={t(copy.langToggle)} className="flex items-center gap-1.5 rounded-lg border border-navy/15 px-2.5 py-1.5 font-display text-xs font-bold text-charcoal transition-colors duration-150 ease-out hover:border-bright hover:text-royal" data-id="element-271" data-mp="3631ahy3qppee">
            <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-272" data-mp="2s88nkelit6xs" />
            <span className={lang === 'en' ? 'text-royal' : 'text-charcoal/50'} data-id="element-273" data-mp="2nap6z81coi2o">EN</span>
            <span aria-hidden="true" className="text-charcoal/30" data-id="element-274" data-mp="7jb3592ohcts">
              /
            </span>
            <span className={lang === 'es' ? 'text-royal' : 'text-charcoal/50'} data-id="element-275" data-mp="2khqtjz4nrv7">ES</span>
          </button>
          <a href="#contact" className="ml-1 rounded-xl bg-bright px-5 py-3 font-display text-sm font-bold text-white shadow-sm transition-colors duration-150 ease-out hover:bg-royal" data-id="element-276" data-mp="a37i9whzh268">
            {t(copy.navBook)}
          </a>
        </div>

        <div className="flex items-center gap-1 lg:hidden" data-id="element-277" data-mp="54xpttnn8fob">
          <a href={business.phoneHref} aria-label={`${t(copy.callUs)} ${business.phone}`} className="rounded-lg p-2.5 text-royal transition-colors duration-150 ease-out hover:bg-mist" data-id="element-278" data-mp="sva3ll5kl6mt">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-279" data-mp="k3rmn80sumso" />
          </a>
          <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? t(copy.navClose) : t(copy.navMenu)} className="rounded-lg p-2.5 text-charcoal transition-colors duration-150 ease-out hover:bg-mist" data-id="element-280" data-mp="o4bkkdt75ufv">
            {open ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-281" data-mp="3ozkpebxxvnp7" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-282" data-mp="3k4x74utj3pj2" />}
          </button>
        </div>
      </nav>

      {open ? <div id="mobile-menu" className="border-t border-navy/10 bg-white px-4 pb-6 pt-2 shadow-lift lg:hidden" data-id="element-283" data-mp="3b2nxe763406q">
          <ul className="flex flex-col" data-id="element-284" data-mp="bmiywjsm5ehz">
            {navLinks.map(link => <li key={link.href} data-id="element-285" data-mp="6oz8ymmjzda7">
                <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-navy/5 py-3.5 font-display text-base font-bold text-charcoal" data-id="element-286" data-mp="6q0ujl173i66">
                  {t(copy[link.key])}
                </a>
              </li>)}
          </ul>
          <div className="mt-5 flex items-center justify-between gap-3" data-id="element-287" data-mp="pma7g50d22ol">
            <button type="button" onClick={toggle} aria-label={t(copy.langToggle)} className="flex items-center gap-1.5 rounded-lg border border-navy/15 px-3 py-2 font-display text-xs font-bold text-charcoal" data-id="element-288" data-mp="pkz60bue170n">
              <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-289" data-mp="2h8x64bzw6kam" />
              <span className={lang === 'en' ? 'text-royal' : 'text-charcoal/50'} data-id="element-290" data-mp="2ma4bk4ekb7e4">EN</span>
              <span aria-hidden="true" className="text-charcoal/30" data-id="element-291" data-mp="2r7cwgcr3hpj2">
                /
              </span>
              <span className={lang === 'es' ? 'text-royal' : 'text-charcoal/50'} data-id="element-292" data-mp="2w67p06ev6sgd">ES</span>
            </button>
            <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex items-center gap-2 font-display text-sm font-bold text-royal" data-id="element-293" data-mp="30yr2z4hgrplp">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-294" data-mp="39x2owt7dxz7t" />
              WhatsApp
            </a>
          </div>
          <a href="#contact" onClick={() => setOpen(false)} className="mt-4 block rounded-xl bg-bright px-5 py-3.5 text-center font-display text-base font-bold text-white" data-id="element-295" data-mp="1evhcka36pbs2">
            {t(copy.navBook)}
          </a>
        </div> : null}
    </header>;
}